import { Collapse } from '@mui/material';
import { FC } from 'react';
import NoConnectivityBanner from '../components/NoConnectivityBanner';
import RevokedConnectivityBanner from '../components/RevokedConnectivityBanner';
import { NoConnectivityReason } from '../connector-connectivity-types';
import useConnectivityBanner from '../hooks/use-connectivity-banner';

const ConnectivityBannerContainer: FC = () => {
  const { show, noConnectionBanner, dismissBanner } = useConnectivityBanner();

  return (
    <Collapse in={show}>
      {noConnectionBanner && (
        <>
          {noConnectionBanner.reason === NoConnectivityReason.NotConnected && (
            <NoConnectivityBanner />
          )}
          {noConnectionBanner.reason ===
            NoConnectivityReason.ExpiredOrRevoked && (
            <RevokedConnectivityBanner
              info={noConnectionBanner}
              onClose={dismissBanner}
            />
          )}
        </>
      )}
    </Collapse>
  );
};

export default ConnectivityBannerContainer;
